const NavContact = () => {
  return (
    <div id="contact" className="nav-delivery-container">
      <p>Contactenos</p>
    </div>
  );
};

export default NavContact;
